import session from "@/services/SessionService";
import config from "@/config";
import { AxiosPromise } from "axios";
import { Budget } from "@/models/Budget";
/**
 * Type for all available budget filters
 */
export type BudgetFilters = {
  id?: number;
  contact?: number;
};
/**
 * Response type for budget data
 */
type BudgetResponse = Budget[] | Budget | undefined;

/**
 * Singleton class for fetching budget data from the API
 */
class BudgetService {
  private endpoint: string = config.hostname + "/budgets/";
  /**
   * Fetch all budgets matching the filters provided
   *
   * @param {BudgetFilters} filters
   *
   */

  get = (filters: BudgetFilters): AxiosPromise<BudgetResponse> => {
    let promise: AxiosPromise<BudgetResponse>;
    if (filters.id) {
      promise = session.requestWithAuth(
        "get",
        this.endpoint + String(filters.id)
      );
    } else {
      promise = session.requestWithAuth("get", this.endpoint, filters);
    }
    return promise;
  };
  /**
   * Saves or updates the budget provided
   *
   * @param {Budget} budget
   */
  private save = (budget: Budget): AxiosPromise<Budget> => {
    let promise: AxiosPromise<Budget>;
    if (budget.id) {
      promise = session.requestWithAuth(
        "put",
        this.endpoint + String(budget.id),
        undefined,
        budget
      );
    } else {
      promise = session.requestWithAuth(
        "post",
        this.endpoint,
        undefined,
        budget
      );
    }
    return promise;
  };
  /**
   * Deletes the provided budget
   *
   * @param {Budget} budget
   */
  private delete = (budget: Budget): AxiosPromise => {
    let promise: AxiosPromise;
    if (budget.id) {
      promise = session.requestWithAuth(
        "delete",
        this.endpoint + String(budget.id)
      );
    } else {
      promise = new Promise((resolve, reject) => {
        resolve();
      });
    }
    return promise;
  };
}

let budgetService = new BudgetService();

export default budgetService;
